var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-add-user.218bdc84.png","uri@3x": __webpack_public_path__ + "icon-add-user.fd6a462e.png","uri@2x": __webpack_public_path__ + "icon-add-user.492095c5.png",
    width: 48,
    height: 47
});